'use client';

import * as React from 'react';

import type { ClassValue, VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

const tagVariants = tv({
  slots: {
    base: 'inline-flex justify-center items-center rounded-lg px-2 pr-1 py-1 bg-additional-wisteria text-white',
    text: '',
    icon: 'inline-flex items-center justify-center text-white rounded-full bg-black/20',
  },
  variants: {
    size: {
      sm: {
        base: 'gap-1',
        text: 'text-body-5',
        icon: 'text-body-5 w-5 h-5',
      },
      md: {
        base: 'gap-2',
        text: 'text-body-4',
        icon: 'text-body-2 w-5 h-5',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export type TagProps = {
  rightSection?: React.ReactNode;
  classNames?: {
    base?: ClassValue;
    text?: ClassValue;
    icon?: ClassValue;
  };
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> &
  VariantProps<typeof tagVariants>;

const Tag = React.forwardRef<HTMLDivElement, TagProps>(
  ({ size, rightSection, children, classNames, ...props }, ref) => {
    const { base, icon, text } = tagVariants({
      size,
    });

    return (
      <div className={base({ class: classNames?.base })} ref={ref} {...props}>
        <span className={text({ class: classNames?.text })}>{children}</span>
        {rightSection ? (
          <span className={icon({ class: classNames?.icon })}>
            {rightSection}
          </span>
        ) : null}
      </div>
    );
  },
);

Tag.displayName = 'Tag';

export { Tag, tagVariants };
